import React, { useEffect } from "react";

import TaktileIcon from "src/assets/Taktile.svg?react";
import { useRemoteIcon } from "src/connections/queries";
import { DashboardPageParams } from "src/router/urls";
import { logger } from "src/utils/logger";
import { useParamsDecode } from "src/utils/useParamsDecode";

const taktileMediaKey = "taktile-icon";

interface CustomIconProps {
  mediaKey: string | null;
  className?: string;
}

export const CustomIcon: React.FC<CustomIconProps> = ({
  mediaKey,
  className,
}) => {
  const { wsId } = useParamsDecode<DashboardPageParams>();
  const {
    data: iconSrc,
    isError,
    isLoading,
    error,
  } = useRemoteIcon(mediaKey, wsId);

  useEffect(() => {
    if (isError) {
      logger.warn(
        "There was an error fetching the icon image",
        JSON.stringify(error),
      );
    }
  }, [isError, error]);

  // Special case: show taktile icon directly
  if (mediaKey === taktileMediaKey) {
    return <TaktileIcon className={className} />;
  }

  if (isLoading || !iconSrc || isError) {
    return <div />;
  }

  return (
    <img
      alt="Custom Icon"
      className={className}
      data-loc="custom-icon"
      src={iconSrc}
    />
  );
};
